import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Modal, Button, Typography, Tabs, Tab } from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import Iconify from '../../iconify/Iconify';
import '../../../css/table.css';
import { getViewUser } from '../../../redux/actions/userlistaction';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function Viewmodel(props) {
  const { viewopen, handleViewClose, name, userId } = props;
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [onBoardedUserData, setOnBoardedUserData] = useState({});
  const [dynamicUserData, setDynamicUserData] = useState({});
  const [staticUserData, setStaticUserData] = useState({});

  const userData = useSelector((state) => {
    return state?.User?.getViewuser?.data;
  });

  const navigate = useNavigate();

  const ViewTicket = () => {
    navigate(`/dashboard/ticket/${userId}`);
  };

  const ViewTransaction = () => {
    navigate(`/dashboard/transaction/${userId}`);
  };

  useEffect(() => {
    setOnBoardedUserData({
      'User Id': userData?.UserId,
      Name: userData?.Name,
      'Employer Id': userData?.EmployerId,
      'KYC Status': userData?.kycstatus,
      Location: userData?.Location,
      'Phone Number': userData?.PhoneNumber,
      'Referral Code': userData?.ReferralCode,
      'Referral Earnings': userData?.ReferralEarnings,
      Profile: userData?.imageUrl,
      Pan: userData?.pancardUrl,
      'Withdrawn Amount': userData?.dynamicData?.withdrawalAmount,
      'Aadhar Card': userData?.dynamicData?.AdharCard,
      'Pan Card': userData?.dynamicData?.PanNumber,
    });
    setDynamicUserData({
      'User Id': userData?.UserId,
      Name: userData?.Name,
      'Employer Id': userData?.EmployerId,
      'LOP Days': userData?.dynamicData?.LOPDays,
      'YearEnd Settlement': userData?.dynamicData?.YearEndSettlements,
      Terminated: userData?.dynamicData?.Terminated,
      'Notice Period': userData?.dynamicData?.NoticePeriod,
      'Probation Period': userData?.dynamicData?.ProbationPeriod,
      'Temporary Deactivation': userData?.dynamicData?.TemporaryDeactivation,
      'Withdrawal Factor': userData?.dynamicData?.WithdrawalFactor,
      'MinAmt Value': userData?.dynamicData?.MinAmtValue,
      'Employee OutStanding': userData?.dynamicData?.EmployeeOutStanding,
      'LastDate of Employement': userData?.dynamicData?.LastDateOfEmployement,
      'Max Salary Band': userData?.dynamicData?.MaxSalaryBand,
    });
    setStaticUserData({
      'User Id': userData?.UserId,
      Name: userData?.Name,
      'Email Id': userData?.EmployeeEmailId,
      'Phone Number': userData?.PhoneNumber,
      'Employer Id': userData?.EmployerId,
      Date: userData?.CreatedAt ? dayjs(userData?.CreatedAt).format('YYYY-MM-DD') : '',
      'Employee ID': userData?.dynamicData?.EmployeeID,
      'Employment Type': userData?.dynamicData?.EmploymentType,
      'Employee Risk Category': userData?.dynamicData?.EmployeeRiskCategory,
      'Employer Risk Category': userData?.dynamicData?.EmployerRiskCategory,
      'Employee Email Id': userData?.dynamicData?.EmployeeEmailId,
      Designation: userData?.dynamicData?.Designation,
      City: userData?.dynamicData?.City,
      'Year of Joining': userData?.dynamicData?.YearOfJoining,
      'Employment Status': userData?.dynamicData?.EmploymentStatus,
      Bank: userData?.dynamicData?.Bank,
      'Bank Account Number': userData?.dynamicData?.BankAccountNumber,
      'IFSC Number': userData?.dynamicData?.IFSCNumber,
      'Pan Number': userData?.dynamicData?.PanNumber,
      'Adhar Card': userData?.dynamicData?.AdharCard,
      ESOPs: userData?.dynamicData?.ESOPs,
      Month: userData?.dynamicData?.Month,
      Paydays: userData?.dynamicData?.Paydays,
      'Net Salary': userData?.dynamicData?.NetSalary,
      'Gross Salary': userData?.dynamicData?.GrossSalary,
      'Fixed Salary': userData?.dynamicData?.FixedSalary,
      'Fixed Variable Salary': userData?.dynamicData?.FixedVariableSalary,
      Bonus: userData?.dynamicData?.Bonus,
      Deductions: userData?.dynamicData?.Deductions,
      'LOP Days': userData?.dynamicData?.LOPDays,
      Overtime: userData?.dynamicData?.Overtime,
      Allowance: userData?.dynamicData?.Allowance,
      Arrears: userData?.dynamicData?.Arrears,
      Reimbursements: userData?.dynamicData?.Reimbursements,
      'Relocation Expenses': userData?.dynamicData?.RelocationExpenses,
      'Loan EMI from Company': userData?.dynamicData?.LoanEMIFromCompany,
      'Company Creditcard Usage': userData?.dynamicData?.CompanyCreditCardUsage,
      'Advance Lieu Company Expenses': userData?.dynamicData?.AdvanceLieuCompanyExpenses,
      'Year end Settlements': userData?.dynamicData?.YearEndSettlements,
      // 'Loss of Pay Days': userData?.dynamicData?.LossOfPayDays,
      'Resignation Date': userData?.dynamicData?.ResignationDate,
      'Notice Period': userData?.dynamicData?.NoticePeriod,
      Terminated: userData?.dynamicData?.Terminated,
      'on Probation': userData?.dynamicData?.OnProbation,
      'Probation Period': userData?.dynamicData?.ProbationPeriod,
      'on Sabbatical': userData?.dynamicData?.OnSabbatical,
      'Sabbatical Period': userData?.dynamicData?.SabbaticalPeriod,
      'Employee Outstanding': userData?.dynamicData?.EmployeeOutstanding,
      'LastDate of Employment': userData?.dynamicData?.LastDateOfEmployment,
    });
  }, [userData]);

  useEffect(() => {
    if(viewopen === true){
      dispatch(getViewUser(userId));
    }
  }, [viewopen, userId]);

  const handletabChange = (event, newValue) => {
    setValue(newValue);
  };

  const style1 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 10,
    p: 2,
    transition: 'left 0.5s ease-in-out',
  };
  const style2 = {
    display: 'flex',
    flexDirection: 'column',
  };
  return (
    <>
      {/* edit model */}

      <Modal
        style={style2}
        open={viewopen}
        onClose={handleViewClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style1, left: '50%' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '10px',
              paddingX: '20px',
            }}
          >
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handletabChange} aria-label="basic tabs example">
                <Tab label="Onboarded user" {...a11yProps(0)} />
                <Tab label="Dynamic user" {...a11yProps(1)} />
                <Tab label="Static user" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <Iconify style={{ cursor: 'pointer' }} onClick={handleViewClose} icon={'material-symbols:close'} />
          </Box>

          <CustomTabPanel value={value} index={0}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <h2>Onboarded User Data</h2>
            </div>
            <table style={{ border: '1px solid black', borderCollapse: 'collapse', width: '100%' }}>
              {onBoardedUserData &&
                Object.keys(onBoardedUserData).map((key) => {
                  return (
                    <>
                      <tr>
                        <th
                          style={{
                            border: '1px solid black',
                            borderCollapse: 'collapse',
                            padding: '5px',
                            textAlign: 'start',
                            width: '200px',
                          }}
                        >
                          {key}{' '}
                        </th>
                        <td style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '5px' }}>
                          {onBoardedUserData?.[key]}
                        </td>
                      </tr>
                    </>
                  );
                })}
            </table>
            <Typography style={{ fontWeight: 'Bold', marginTop: '20px' }}>Tickets : </Typography>
            <ul style={{ marginLeft: '20px' }}>
              {userData?.tickets?.map((item) => (
                <>
                  <li>
                    {item?.ticketId} - {item?.data}
                  </li>
                </>
              ))}
            </ul>
          </CustomTabPanel>

          {/* dynamic user */}
          <CustomTabPanel value={value} index={1}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <h2>User Dynamic Data</h2>
            </div>
            <table style={{ border: '1px solid black', borderCollapse: 'collapse', width: '100%' }}>
              {dynamicUserData &&
                Object.keys(dynamicUserData).map((key) => {
                  return (
                    <>
                      <tr>
                        <th
                          style={{
                            border: '1px solid black',
                            borderCollapse: 'collapse',
                            padding: '5px',
                            textAlign: 'start',
                            width: '200px',
                          }}
                        >
                          {key}{' '}
                        </th>
                        <td style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '5px' }}>
                          {dynamicUserData?.[key]}
                        </td>
                      </tr>
                    </>
                  );
                })}
            </table>
            <Typography style={{ fontWeight: 'Bold', marginTop: '20px' }}>Tickets : </Typography>
            <ul style={{ marginLeft: '20px' }}>
              {userData?.tickets?.map((item) => (
                <>
                  <li>
                    {item?.ticketId} - {item?.data}
                  </li>
                </>
              ))}
            </ul>
          </CustomTabPanel>

          {/* static tab */}
          <CustomTabPanel value={value} index={2}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <h2>User Static Data</h2>
            </div>
            <table style={{ border: '1px solid black', borderCollapse: 'collapse', width: '100%' }}>
              {staticUserData &&
                Object.keys(staticUserData).map((key) => {
                  return (
                    <>
                      <tr>
                        <th
                          style={{
                            border: '1px solid black',
                            borderCollapse: 'collapse',
                            padding: '5px',
                            textAlign: 'start',
                            width: '200px',
                          }}
                        >
                          {key}{' '}
                        </th>
                        <td style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '5px' }}>
                          {staticUserData?.[key]}
                        </td>
                      </tr>
                    </>
                  );
                })}
            </table>
            <Typography style={{ fontWeight: 'Bold', marginTop: '20px' }}>Tickets : </Typography>
            <ul style={{ marginLeft: '20px' }}>
              {userData &&
                userData?.tickets?.map((item) => (
                  <>
                    <li>
                      {item?.ticketId} - {item?.data}
                    </li>
                  </>
                ))}
            </ul>
          </CustomTabPanel>

          <Button style={{ marginTop: '20px', marginLeft: '10px' }} onClick={ViewTicket} variant="outlined">
            ViewTickets
          </Button>
          <Button style={{ marginTop: '20px', marginLeft: '10px' }} onClick={ViewTransaction} variant="outlined">
            Transaction
          </Button>

          <Button style={{ marginTop: '20px', marginLeft: '10px' }} onClick={handleViewClose} variant="outlined">
            Cancel
          </Button>
        </Box>
      </Modal>
    </>
  );
}

export default Viewmodel;
